import api from './api';

export interface TechnicianLocation {
  userId: string;
  userName: string;
  lat: number;
  lon: number;
  accuracy: number | null;
  speed: number | null;
  recordedAt: string;
}

export interface GpsPoint {
  lat: number;
  lon: number;
  accuracy: number | null;
  speed: number | null;
  recordedAt: string;
}

/** GET /gps/locations — Latest location of all active technicians */
export async function getLocations(): Promise<TechnicianLocation[]> {
  const res = await api.get<TechnicianLocation[]>('/gps/locations');
  return res.data;
}

/** GET /gps/track/:userId — GPS track for a user on a given day */
export async function getTrack(userId: string, date: string): Promise<GpsPoint[]> {
  const res = await api.get<GpsPoint[]>(`/gps/track/${userId}`, { params: { date } });
  return res.data;
}

/** POST /gps/log — Batch send GPS points */
export async function logPoints(
  points: { lat: number; lon: number; accuracy?: number; speed?: number; timestamp: string }[],
): Promise<void> {
  await api.post('/gps/log', { points });
}

/** PATCH /tracking/status — Set technician status manually */
export async function setTechStatus(
  status: 'available' | 'en_route' | 'working' | 'off_duty',
  workOrderId?: string,
): Promise<void> {
  await api.patch('/tracking/status', {
    status,
    ...(workOrderId && { work_order_id: workOrderId }),
  });
}
